import * as TYPES from './types'

/**
 * Default Discord State
 */
export const defaultState: TYPES.DiscordState = {
    httpInProgress: false,
    httpUpdateInProgress: false,
    httpError: ''
}

// define initial state object
const initialState: TYPES.DiscordState = {
  httpInProgress: defaultState.httpInProgress,
  httpUpdateInProgress: defaultState.httpUpdateInProgress,
  httpError: defaultState.httpError
}

// define discord reducer
export function discordReducer (
  state = initialState,
  action: TYPES.DiscordActionTypes
): TYPES.DiscordState {
  switch (action.type) {
    case TYPES.DISCORD_IN_PROGRESS: {
        return {
            ...state,
            ...{ httpInProgress: true, httpUpdateInProgress:false, httpError: '' }
      }
    }
    case TYPES.DISCORD_UPDATE_IN_PROGRESS: {
        return {
            ...state,
            ...{ httpInProgress: false, httpUpdateInProgress:true, httpError: '' }
      }
    }
    case TYPES.DISCORD_ERROR: {
        return {
            ...state,
            ...{ httpInProgress: false, httpUpdateInProgress:false, httpError: action.error }
        }
    }
    case TYPES.DISCORD_SUCCESS: {
        return {
          ...state,
          ...{ httpInProgress: false, httpUpdateInProgress:false, httpError: '' }
        }
    }
    default:
        return state
  }
}
